import React, { Component } from 'react'
import { TextArea, DropdownV2 } from 'carbon-components-react';
import { toast } from 'react-toastify';
import moment from 'moment'
import { insertDmService, deleteDmService, updateDmService, getDmService } from '../../../services/Api';
import ModalDm from '../../Modal/ModalDm';

class OrderHistory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openOcorrencia: false,
      idItem: 0,
      perfil: []
    }
  }

  getPermissoes = async () => {
    const data = await getDmService('/Ocorrencia/GetNiveis');

    const items = Object.keys(data).map((key) => ({ id: key, label: data[key] }));
    // console.log("items", items)
    this.setState({ perfil: items.filter(p => p.id !== "10,30,50,60") });
  }

  componentWillMount = async () => {
    await this.getPermissoes();
  }

  editHistorico = (id) => {
    const { data, isTrade } = this.props;
    const { perfil } = this.state;
    const item = data.find(p => p.id === id) || {};
    const descricao = item.mensagem;
    const selectedProfile = perfil.find(x => x.id === (isTrade ? "0" : item.perfil));

    this.setState({ idItem: id, descricao, selectedProfile });
    this.toggleModal('openOcorrencia');
  }

  save = async () => {
    const { descricao, selectedProfile, idItem } = this.state;
    const { match, onChange, nivel } = this.props;
    let _selectedProfile = selectedProfile;
    if (nivel === 40)
      _selectedProfile = { id: "0", label: "Todos" };
    const obj =
    {
      "IdPedido": match.params.id,
      "Perfil": (_selectedProfile || {}).id,
      "Mensagem": descricao
    }
    if (!descricao) {
      toast.warn("Digite o descritivo")
    } else if (!_selectedProfile) {
      toast.warn("Selecione o perfil")
    }
    else {
      try {
        if (idItem > 0) {
          await updateDmService('/Ocorrencia/', idItem, obj);
        } else {
          await insertDmService('/Ocorrencia/', obj);
        }
        toast.success('Dados atualizados com sucesso');
        this.setState({ descricao: "" });
        onChange();
        this.toggleModal('openOcorrencia')
      } catch (e) {
        this.errorHandler(e);
      }
    }
  }

  delete = async (id) => {
    const { onChange } = this.props;
    try {
      await deleteDmService('/Ocorrencia/', id);
      toast.success('Item removido com sucesso');
      onChange();
      this.setState({ descricao: null });
      this.toggleModal('openOcorrencia')
    } catch (e) {
      this.errorHandler(e);
    }
  }

  errorHandler = err => {
    if (typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  toggleModal = (modal) => {
    this.setState(prevState => ({
      [modal]: !prevState[modal]
    }));
  }

  onChange = (item, change) => {
    if (change === "nivel") {
      this.setState({ selectedProfile: item.selectedItem });
    } else {
      this.setState({ selectedSupervisor: item.selectedItem });
    }
  };

  onChangeInput = (event, change) => {
    if (change === "nivel") {
      this.setState({ selectedProfile: event.selectedItem });
    } else {
      this.setState({ [event.target.id]: event.target.value });
    }
  };

  render() {
    const { data, nivel, isTrade } = this.props
    const { openOcorrencia, descricao, perfil, selectedProfile, idItem } = this.state;
    const userValues = JSON.parse(localStorage.getItem("user"));
    const permissionForAgency = userValues.agencia;
    const history = nivel !== 10 ? data.filter(x => x.perfil !== "10") : data;

    return (
      <div className="order-history">
        <div className="bx--row header-order-history">
          <div className="bx--col-md-10 bx--col-xs-12">
            <h3>Histórico do Pedido</h3>
            <p className="description">Interação entre as partes interessadas</p>
          </div>
          {(!!isTrade || nivel === 40 || (nivel === 10 && permissionForAgency)) && (
            <div className="bx--col-md-2 bx--col-xs-12">
              <button
                className="bx--btn btn-secondary-outlined"
                style={{ float: "right" }}
                type="button"
                onClick={() => { this.editHistorico(0) }}
              >
                Adicionar Ocorrência
              </button>
            </div>
          )}
        </div>
        <div>
          {history && history.map(item => (
            <div className="bx--row item-order-history" key={`k${item.id}`} style={{ background: item.perfil !== "10" ? "rgba(245, 166, 35, 0.26)" : "" }}>
              <div className="bx--col-md-10 bx--col-xs-12">
                <p style={{whiteSpace: "pre-line"}}>
                  {moment(item.dataCadastro).format("DD/MM/YY | HH:mm ")}
                  <strong>
                    {item.usuario}
                  </strong>
                  {` ${item.mensagem}`}
                </p>

              </div>
              {(nivel === 10 && permissionForAgency) && (
                <div className="bx--col-md-2 bx--col-xs-12 actions-history">
                  <p className="perfil-ocorrencia">{item.perfilNome}</p>
                  {!item.isAutomatico && (
                    <button
                      className="bx--btn btn-secondary-outlined f-right btn-history"
                      type="button"
                      onClick={() => { this.editHistorico(item.id) }}
                    >
                      Editar
                    </button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        <ModalDm
          openModal={() => { this.toggleModal('openOcorrencia') }}
          heading="Adicionar Ocorrência"
          hiddenModal={() => { this.toggleModal('openOcorrencia') }}
          openMd={openOcorrencia}
        >
          <div>
            <div className="bx--modal-content">
              {nivel === 10 && (
                <div className="bx--row">
                  <div className="bx--col-md-8">
                    <label htmlFor="nivel">Perfil de Permissões</label>
                    <br />
                    <DropdownV2
                      label="Selecionar o perfil"
                      id="nivel"
                      items={perfil}
                      selectedItem={selectedProfile}
                      onChange={e => this.onChangeInput(e, "nivel")}
                    />
                  </div>
                </div>
              )}
              <div className="bx--row" style={{ marginTop: "30px" }}>
                <div className="bx--col-md-12">
                  <label htmlFor="descricao">O que você precisa informar sobre este pedido?</label>
                  <br />
                  <TextArea
                    labelText=""
                    id="descricao"
                    value={descricao}
                    onChange={this.onChangeInput}
                    placeholder="Digite"
                  />
                </div>
              </div>
            </div>
            <div className="bx--modal-footer">
              <div className="bx--row btn-actions">
                <div className="bx--col-md-12 bx--col-xs-12">
                  {!!idItem && (
                    <div className="f-left">
                      <button
                        className="bx--btn btn-primary-outlined h-sm-margin"
                        type="button"
                        onClick={() => { this.delete(idItem) }}
                      >
                        Deletar ocorrência
                      </button>
                    </div>
                  )}
                  <div className="f-right">
                    <button
                      className="bx--btn btn-secondary-outlined h-sm-margin"
                      type="button"
                      onClick={() => { this.toggleModal('openOcorrencia') }}
                    >
                      Cancelar
                    </button>
                    <button
                      className="bx--btn btn-secondary-color h-sm-margin"
                      type="button"
                      onClick={async () => this.save()}
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalDm>
      </div>

    )
  }
}

export default OrderHistory;



// WEBPACK FOOTER //
// ./src/components/agency/requests/OrderHistory.js